import RetireSpokePage from "@/components/retire-spoke/RetireSpokePage";

const RetireAt50 = () => <RetireSpokePage age={50} />;

export default RetireAt50;
